import gql from 'graphql-tag'

export const QUERY_CAMPAIGNS_EXTRA_NUMBERS = gql`
  query CampaignsExtraNumbers($page: Int, $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    campaignsExtraNumbers(page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection) {
      records
      page
      campaignsExtraNumbers {
        _id
        name
        email
        document_no
        phone
        phone_secondary
        email
        birth_date
        created_at
        updated_at
      }
    }
  }
`

export const MUTATION_EDIT_EXTRA_NUMBER = gql`
  mutation UpsertCampaignExtraNumber($data: CampaignExtraNumberInput!) {
    upsertCampaignExtraNumber(data: $data) {
      _id
    }
  }
`

export const MUTATION_CREATE_EXTRA_NUMBER = gql`
  mutation UpsertCampaignExtraNumber($data: CampaignExtraNumberInput!) {
    upsertCampaignExtraNumber(data: $data) {
      _id
    }
  }
`

export const MUTATION_DELETE_EXTRA_NUMBER = gql`
  mutation deleteCampaignExtraNumber($_id: ID!) {
    deleteCampaignExtraNumber(_id: $_id)
  }
`

export const MUTATION_POINTS = gql`
  mutation UpdateAppPointsConfiguration(
    $homeButton: Boolean!
    $durationType: PointsDurationType!
    $rate: Float
    $startDate: String
    $ruleUrl: String
    $endDate: String
    $duration: ConfigurationPointsDurationInput
    $id: ID!
  ) {
    updateAppPointsConfiguration(
      home_button: $homeButton
      duration_type: $durationType
      rate: $rate
      start_date: $startDate
      rule_url: $ruleUrl
      end_date: $endDate
      duration: $duration
      _id: $id
    )
  }
`
